
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"グループ 449"}},[_c('g',{attrs:{"data-name":"パス 538","fill":"#fff"}},[_c('path',{attrs:{"d":"M20 39a18.938 18.938 0 01-13.435-5.565A18.938 18.938 0 011 20 18.938 18.938 0 016.565 6.565 18.938 18.938 0 0120 1a18.938 18.938 0 0113.435 5.565A18.938 18.938 0 0139 20a18.938 18.938 0 01-5.565 13.435A18.938 18.938 0 0120 39z"}}),_c('path',{attrs:{"d":"M20 2A17.882 17.882 0 007.272 7.272C3.872 10.672 2 15.192 2 20s1.872 9.328 5.272 12.728C10.672 36.128 15.192 38 20 38s9.328-1.872 12.728-5.272C36.128 29.328 38 24.808 38 20s-1.872-9.328-5.272-12.728C29.328 3.872 24.808 2 20 2m0-2c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0z","fill":"#12b6d4"}})]),_c('g',{attrs:{"data-name":"グループ 448","fill":"none","stroke":"#12b6d4","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"線 100","d":"M27.126 26.797L13.503 13.174"}}),_c('path',{attrs:{"data-name":"線 101","d":"M27.125 13.172L13.502 26.795"}})])])])
          )
        }
      }
    